import type { ICurrentUser } from '@/stores/authStore';
import { useAuthStore } from '@/stores/authStore';
import { useAutosaveStore } from '@/stores/autosaveStore';

/** Autosave must not run under admin role or Sign In As. */
export function isAutosaveSuppressedByAuth(currentUser: ICurrentUser | undefined): boolean {
  return Boolean(currentUser?.usingSignInAs || currentUser?.selectedRole === 0);
}

/** User preference combined with auth-context suppression. */
export function useAutosaveActive(): boolean {
  const enabled = useAutosaveStore((state) => state.enabled);
  const currentUser = useAuthStore((state) => state.currentUser);
  return enabled && !isAutosaveSuppressedByAuth(currentUser);
}
